import { SvgIconProps, Tooltip, TooltipProps } from '@mui/material'
import React from 'react'
import HelpOutline from '@mui/icons-material/HelpOutline'

const Helper = ({
  toolTipProps,
  iconProps,
}: {
  toolTipProps: Omit<TooltipProps, 'children'>
  iconProps?: SvgIconProps
}) => {
  return (
    <Tooltip placement="top" arrow {...toolTipProps}>
      <HelpOutline {...iconProps} />
    </Tooltip>
  )
}

export default Helper
